const getFilesUrl = (fileRef) => {
  if (!fileRef || !fileRef.id || !fileRef.node) {
    return null;
  }
  const {
    id,
    node
  } = fileRef;
  const url = process.env.REACT_APP_FILES_URL.replace("repository", node);
  return `${url}files?id=${id}&token=${localStorage.jwtToken}`;
};

export default getFilesUrl;



// WEBPACK FOOTER //
// ./src/helpers/getFilesUrl.js